import { ProtectedRoute } from "@app/protected-route";
import { Aion } from "@pages/aion/aion";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/aion/")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<ProtectedRoute requiredPermissions={["root", "see_all_logs"]}>
			<Aion />
		</ProtectedRoute>
	);
}
